import { FileText } from 'lucide-react';
import { SummarySectionCard } from './SummarySectionCard';

export function BaseInfoSummary({ data }: { data: any }) {
  return (
    <SummarySectionCard title="1. Informations de base" icon={FileText}>
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-gray-500 mb-1">Nom de l'espace</p>
            <p className="font-semibold text-gray-900">{data.name || '-'}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-1">Slug (URL)</p>
            <p className="font-mono text-sm text-gray-700">{data.slug || '-'}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-1">Catégorie</p>
            <p className="font-semibold text-gray-900">{data.category || '-'}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-1">Durée par défaut</p>
            <p className="font-semibold text-gray-900">
              {data.defaultDuration === 'full_day' && 'Journée complète'}
              {data.defaultDuration === 'half_day' && 'Demi-journée'}
              {data.defaultDuration === 'hourly' && "À l'heure"}
            </p>
          </div>
        </div>
        {data.description && (
          <div>
            <p className="text-xs text-gray-500 mb-1">Description</p>
            <p className="text-sm text-gray-700 line-clamp-2">{data.description}</p>
          </div>
        )}
      </div>
    </SummarySectionCard>
  );
}
